import React from 'react';
import { BentoBoxRenedererProps } from './types/BentoBoxRenedererProps';
import ContentBentoBox from '../../../Bento/components/ContentBentoBox';
import { ContentBentoBoxTile } from '../../../Bento/components/ContentBentoBox/types/ContentBentoBoxTile';
import ProductBentoBox from '../../../Bento/components/ProductBentoBox';
import { ProductBentoBoxTile } from '../../../Bento/components/ProductBentoBox/types/ProductBentoBoxTile';
import TextImageBentoBox from '../../../Bento/components/TextImageBentoBox';
import { TextImageBentoBoxTile } from '../../../Bento/components/TextImageBentoBox/types/TextImageBentoBoxTile';

export default function BentoBoxRenederer({
  parsedComponents,
  choiceId,
  trackingPrefix,
}: Readonly<BentoBoxRenedererProps>) {
  if (choiceId === 'normal-bento-box') {
    return (
      <ContentBentoBox
        tile={parsedComponents as ContentBentoBoxTile}
        trackingPrefix={trackingPrefix}
      />
    );
  } if (choiceId === 'product-bento-box') {
    return (
      <ProductBentoBox
        tile={parsedComponents as ProductBentoBoxTile}
        trackingPrefix={trackingPrefix}
      />
    );
  } if (choiceId === 'text-image-bento-box') {
    return (
      <TextImageBentoBox
        tile={parsedComponents as TextImageBentoBoxTile}
        trackingPrefix={trackingPrefix}
      />
    );
  }
  return null;
}
